// @flow
import type {AjaxActionType} from 'constants/flow/flowTypes';

/**
 * Cms reducer
 * @param {object} state Current state
 * @param {AjaxActionType} action Received action
 * @returns {{}} state New state
 */
export default function customPopup(state: {} = {data: {content: ''}}, action: AjaxActionType): {} {
    switch (action.type) {
        case 'GET_CUSTOM_POPUP_FULFILLED':
            return {...action.payload.data, status: 'fulfilled'};
        case 'GET_CUSTOM_POPUP_PENDING':
            return {...state, status: 'pending'};
        default:
            return state;
    }
}
